import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { restApi } from 'apis'
import { authReducer } from 'store/AuthSlice'
import { persistStore } from 'redux-persist'
import { orderingReducer } from 'store/OrderingSlice'
import { recaptchaReducer } from './RecaptchaSlice'
import { appSettingsReducer } from './AppSettingsSlice'
import { redirectReducer } from './RedirectSlice'
import userApi from 'apis/UserApi'
import paymentMethodApi from 'apis/PaymentMethodApi'

export const reduxStore = configureStore({
  reducer: {
    auth: authReducer,
    ordering: orderingReducer,
    recaptcha: recaptchaReducer,
    appSettings: appSettingsReducer,
    redirect: redirectReducer,
    [restApi.reducerPath]: restApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [paymentMethodApi.reducerPath]: paymentMethodApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      restApi.middleware,
      userApi.middleware,
      paymentMethodApi.middleware,
    ),
})

export const persistor = persistStore(reduxStore)

setupListeners(reduxStore.dispatch)

export type RootState = ReturnType<typeof reduxStore.getState>
export type AppDispatch = typeof reduxStore.dispatch
